import React, { useState, useEffect } from "react"
import { styled } from "styled-components"
import { motion } from "framer-motion"
import { breakpoints } from "../Theme"

const imageArray = [
  "/buddies/Buddy01.svg",
  "/buddies/Buddy02.svg",
  "/buddies/Buddy03.svg",
  "/buddies/Buddy04.svg",
  "/buddies/Buddy05.svg",
  "/buddies/Buddy06.svg",
  "/buddies/Buddy07.svg",
  "/buddies/Buddy08.svg",
  "/buddies/Buddy09.svg",
  "/buddies/Buddy10.svg",
  "/buddies/Buddy11.svg",
  "/buddies/Buddy12.svg",
]

const Wrapper = styled.div`
  position: relative;
`

const Buddy = styled(motion.img)`
  position: absolute;
  width: 70px;
  height: auto;

  @media ${breakpoints.xl} {
    width: 150px;
  }
`

export default function Buddies({ children }) {
  const [randomIndex1, setRandomIndex1] = useState(0)
  const [randomIndex2, setRandomIndex2] = useState(0)

  useEffect(() => {
    // Generate random indices when the component mounts
    const newIndex1 = Math.floor(Math.random() * imageArray.length)
    const newIndex2 = Math.floor(Math.random() * imageArray.length)
    setRandomIndex1(newIndex1)
    setRandomIndex2(newIndex2)
  }, [])

  // Randomly generate top position between 10% to 90% of the parent height
  const topPosition1 = Math.floor(Math.random() * 10) + 10
  const topPosition2 = Math.floor(Math.random() * 10) + 10

  return (
    <Wrapper>
      <Buddy
        src={imageArray[randomIndex1]}
        alt="Buddy"
        style={{
          top: `${topPosition1}%`,
          left: `-25px`,
        }}
        initial={{ scale: 0 }}
        animate={{
          scale: 1,
          transition: {
            delay: 0.5,
          },
        }}
      />
      <Buddy
        src={imageArray[randomIndex2]}
        alt="Buddy"
        style={{
          top: `${topPosition2}%`,
          right: `-25px`,
        }}
        initial={{ scale: 0 }}
        animate={{
          scale: 1,
          transition: {
            delay: 0.6,
          },
        }}
      />
      {children}
    </Wrapper>
  )
}
